// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__16NTE","name":"ConsentHeader_name__1LCIS","birthday":"ConsentHeader_birthday__1DYcJ","skeleton":"ConsentHeader_skeleton__3E9o2"};